import { subscribeOnce, compare, subscribeObservables } from '@/Infrastructure/KnockoutCustomization/KnockoutUtilities';

export default function applyCustomization() {
    ko.observable.fn.equalityComparer = compare;

    ko.observable.fn.toggle = function () {
        let value = this();
        this(!value);

        return this;
    };

    ko.observable.fn.sync = function (target, func) {
        let primary = this;
        let secondary = target;

        subscribeObservables(primary, secondary, func);
    };

    ko.observable.fn.withPausing = function () {
        this.notifySubscribers = function () {
            if (!this.pauseNotifications) {
                ko.subscribable.fn.notifySubscribers.apply(this, arguments);
            }
        };

        this.sneakyUpdate = function (newValue) {
            this.pauseNotifications = true;
            this(newValue);
            this.pauseNotifications = false;
        };

        return this;
    };

    ko.observable.fn.subscribeOnce = subscribeOnce;

    ko.observable.fn.defer = function () {
        let deferred = $.Deferred();

        this.subscribeOnce(function (value) {
            deferred.resolve(value)
        });

        return deferred;
    };
};